import { Card } from 'antd';
import styles from './auth.module.css'
import { SigninForm } from '../../components/features/auth/SigninForm';

const Page = () => {
    return <div className={styles.auth}><Card title="Sign in"><SigninForm /></Card></div>;
}

export default Page;